<template>
  <footer id="footer">
    <div id="footer-chapter">
      <div id="top-footer">
        <div id="promo">
          <v-icon large color="white">mdi-email</v-icon>
          <div>{{ $t("message.FooterSubText") }}</div>
        </div>
        <div id="input">
          <v-dialog v-model="dialog" width="500" id="fb-bg">
            <template v-slot:activator="{ on }">
              <v-card id="fot-card">
                <v-btn v-on="on" id="btnsub">{{ $t("message.FooterSubBtn") }}</v-btn>
              </v-card>
            </template>
            <v-card min-height="500">
              <div id="feedback-marg">
                <Feedback />
              </div>
            </v-card>
          </v-dialog>
        </div>
        <div id="society">
          <!-- <v-btn id="twitter" width="130" height="44">
            <v-icon id="icon">mdi-twitter</v-icon>
            <div id="icon-text">{{ $t("message.Twitter") }}</div>
          </v-btn>
          <v-btn id="linkedin" width="130" height="44">
            <v-icon id="icon">mdi-linkedin</v-icon>
            <div id="icon-text">{{ $t("message.Linkedin") }}</div>
          </v-btn> -->
          <v-btn id="youtube" width="130" height="44" href="https://www.youtube.com/channel/UCGRkaud2YMdVqTr4ahfUC0g">
            <v-icon id="icon">mdi-youtube</v-icon>
            <div id="icon-text">{{ $t("message.Youtube") }}</div>
          </v-btn>
        </div>
      </div>
    </div>
    <div id="bottom-footer">
      <div id="copyright">{{ $t("message.FooterCopyright") }}</div>

      <div id="phone-c">
        <v-icon small color="white">mdi-phone</v-icon>
        <div id="phone-num">{{ $t("message.HeadPhone") }}</div>
      </div>
      <div id="mail-c">
        <v-icon small color="white">mdi-email</v-icon>
        <div id="mail-fot">{{ $t("message.HeadEmail") }}</div>
      </div>
      <!-- <div id="footer-contacts"></div> -->
    </div>
  </footer>
</template>

<script>
import Feedback from "../components/Feedback";
export default {
  name: "Footer",
  components: {
    Feedback,
  },
};
</script>

<style>
/* Футер */
#icon {
  width: 50px;
  height: 45px;
  color: white;
}
#icon-text {
  padding-right: 10px;
  width: 70%;
  color: white;
  /* background-color: #2770ac; */
}
#twitter {
  background: linear-gradient(135deg, rgb(132, 190, 238) 0%, rgb(142, 231, 253) 50%, rgb(51, 167, 181) 100%);
  margin-right: 15px;
  text-decoration: none;
}
#linkedin {
  background: linear-gradient(135deg, rgb(35, 127, 202) 0%, rgb(4, 110, 136) 50%, rgb(37, 102, 109) 100%);
  margin-right: 15px;
  text-decoration: none;
}
#youtube {
  background: linear-gradient(135deg, rgb(243, 7, 7) 0%, rgb(212, 61, 61) 50%, rgb(170, 140, 140) 100%);
  margin-right: 15px;
  text-decoration: none;
}
#footer {
  clear: both;
  color: #969ba5;
  font-size: 12px;
  line-height: 18px;
  min-height: 171px;
  margin-top: 30px;
  position: relative;
  z-index: 0;
  font-family: Ubuntu, Arial, sans-serif;
  animation: mymove 3s;
  animation-delay: 2s;
  animation-fill-mode: forwards;
  background: linear-gradient(135deg, rgb(150, 64, 150) 0%, rgb(238, 144, 225) 50%, rgb(226, 157, 157) 100%);
}
@keyframes mymove {
  100% {
    padding-bottom: 0px;
  }
}

#footer-chapter {
  height: 100%;
  width: 100%;
  padding-left: 25%;
  padding-right: 25%;
}
#footer-chapter::after {
  content: "";
  display: block;
  width: 100%;
  height: 1px;
  margin-top: 10px;
  background-color: #505050;
}

#promo {
  display: flex;
  align-items: center;

  color: #ffffff;
  font-size: 14px;
}

#input {
  display: flex;
  align-items: center;
}
#btnsub {
  background-color: #00569c;
  color: #e3e7ec;
  max-height: 32px;
  margin-bottom: 6px;
}
#society {
  display: flex;
  flex-wrap: wrap;
  /* margin-left: auto;
  margin-right: auto; */
}
#fot-card {
  background-color: #2c364a;
  max-height: 32px;
}
#top-footer {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding-top: 20px;
}
#iconbutton {
  height: 30px;
  width: 30px;
}
#bottom-footer {
  display: flex;
  justify-content: space-around;
  height: 100%;
  width: 100%;
  padding-left: 25%;
  padding-right: 25%;
  padding-top: 20px;
}
#copyright {
  display: flex;
  width: 33%;
  font-size: 10px;
  color: #ffffff;
}
#footer-links {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  width: 60%;
}
#footer-links a {
  color: #ffffff;
  text-transform: uppercase;
  font-size: 12px;
  width: 30%;
  padding-bottom: 15px;
}
#footer-links a:hover {
  text-decoration: none;
}
#footer-contacts {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 25%;
  padding-left: 25px;
}
#phone-c {
  display: flex;
  width: 33%;
  align-items: center;
}
#phone-num {
  font-size: 14px;
  color: #ffffff;
  padding-left: 7px;
}
#mail-c {
  display: flex;
  width: 33%;
}
#mail-fot {
  padding-left: 7px;
  color: #ffffff;
}

@media (max-width: 920px) {
  #top-footer {
    flex-direction: column;
  }
  #footer-links {
    flex-direction: column;
  }
  #send-mail {
    display: none;
  }
  #promo {
    width: 100%;
    justify-content: center;
    padding-top: 10px;
  }
  #footer-chapter {
    padding-left: 5%;
    padding-right: 5%;
  }
  #input {
    width: 100%;
    justify-content: center;
  }
  #society {
    width: 100%;
    justify-content: center;
  }
  #bottom-footer {
    flex-direction: column;
    padding-left: 5%;
    padding-right: 5%;
  }
  #copyright {
    width: 100%;
    justify-content: center;
    padding-bottom: 10px;
  }
  #phone-c {
    width: 100%;
    justify-content: center;
    padding-bottom: 10px;
  }
  #mail-c {
    width: 100%;
    justify-content: center;
    padding-bottom: 10px;
  }
  #footer-links {
    display: none;
  }

  #footer-contacts {
    padding-top: 10px;
    width: 100%;
    justify-content: center;
    align-items: center;
  }
}
@media (max-width: 1650px) {
  #top-footer {
    flex-direction: column;
  }
  #footer-links {
    flex-direction: column;
  }
  #send-mail {
    display: none;
  }
  #promo {
    width: 100%;
    justify-content: center;
    padding-top: 20px;
  }
  #footer-chapter {
    padding-left: 5%;
    padding-right: 5%;
  }
  #input {
    width: 100%;
    justify-content: center;
    padding-left: 0px;
    padding-top: 20px;
  }
  #society {
    width: 100%;
    justify-content: center;
    padding-top: 20px;
  }
}
</style>
